// import { useEffect, useState } from "react";
// import api from "../api/axios";
// import Layout from "../components/Layout";
// import Card from "../components/UI/Card";
// import Input from "../components/UI/Input";
// import Button from "../components/UI/Button";
// import { PageLoader } from "../components/UI/Spinner";

// const ROLES = [ "ADMIN", "MANAGER", "CALLER", "VIEWER"];

// const ROLE_META = {
//   SUPER_ADMIN: { color: "#7c3aed", bg: "#f3e8ff" },
//   ADMIN:       { color: "#2563eb", bg: "#dbeafe" },
//   MANAGER:     { color: "#0891b2", bg: "#cffafe" },
//   CALLER:      { color: "#059669", bg: "#d1fae5" },
//   VIEWER:      { color: "#64748b", bg: "#f1f5f9" },
// };

// export default function Users() {
//   const [users, setUsers] = useState([]);
//   const [msg, setMsg] = useState("");
//   const [loadingUsers, setLoadingUsers] = useState(true);
//   const [form, setForm] = useState({ name: "", email: "", password: "", role: "VIEWER" });
//   const [creating, setCreating] = useState(false);
//   const [showForm, setShowForm] = useState(false);

//   async function load() {
//     setLoadingUsers(true);
//     try {
//       const { data } = await api.get("/users");
//       setUsers(data.users);
//     } finally {
//       setLoadingUsers(false);
//     }
//   }
//   useEffect(() => { load(); }, []);

//   async function create() {
//     if (!form.name.trim()) return setMsg("Name is required.");
//     if (!form.email.trim()) return setMsg("Email is required.");
//     if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) return setMsg("Enter a valid email address.");
//     if (!form.password.trim()) return setMsg("Password is required.");
//     if (form.password.length < 6) return setMsg("Password must be at least 6 characters.");

//     setMsg(""); setCreating(true);
//     try {
//       await api.post("/users", form);
//       setForm({ name: "", email: "", password: "", role: "VIEWER" });
//       setMsg("✅ User created successfully");
//       setShowForm(false);
//       await load();
//     } catch (e) {
//       setMsg(e?.response?.data?.message || "Create failed");
//     } finally {
//       setCreating(false);
//     }
//   }

//   async function updateRole(u, role) {
//     await api.put(`/users/${u._id}`, { name: u.name, role });
//     await load();
//   }

//   async function toggleActive(u) {
//     await api.put(`/users/${u._id}/active`, { isActive: !u.isActive });
//     await load();
//   }

//   async function resetPassword(u) {
//     const newPassword = prompt("Enter new password:");
//     if (!newPassword) return;
//     await api.put(`/users/${u._id}/reset-password`, { newPassword });
//     alert("Password reset + email sent");
//   }

//   return (
//     <Layout>
//       <div className="flex flex-col gap-5 max-w-6xl">

//         {/* ── Page header ── */}
//         <div className="flex items-end justify-between flex-wrap gap-3">
//           <div>
//             <div className="text-[10px] font-bold uppercase tracking-widest mb-1" style={{ color: "rgb(var(--primary))", opacity: 0.7 }}>
//               Management
//             </div>
//             <h1 className="text-2xl font-bold tracking-tight">Users</h1>
//           </div>
//           <div className="flex items-center gap-3">
//             {!loadingUsers && (
//               <div
//                 className="flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-semibold"
//                 style={{ background: "rgba(var(--primary),0.08)", color: "rgb(var(--primary))" }}
//               >
//                 <span className="w-2 h-2 rounded-full" style={{ background: "rgb(var(--primary))" }} />
//                 {users.length} Users
//               </div>
//             )}
//             <button
//               onClick={() => { setShowForm(p => !p); setMsg(""); }}
//               className="flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-semibold text-white transition-opacity hover:opacity-90"
//               style={{ background: "rgb(var(--primary))" }}
//             >
//               {showForm ? (
//                 <>
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
//                   Cancel
//                 </>
//               ) : (
//                 <>
//                   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14"/></svg>
//                   Add New User
//                 </>
//               )}
//             </button>
//           </div>
//         </div>

//         {/* ── Create user form ── */}
//         {showForm && <Card className="overflow-hidden">
//           <div className="px-5 py-3 border-b border-[rgb(var(--border))]" style={{ background: "rgba(var(--primary),0.04)" }}>
//             <div className="text-xs font-bold uppercase tracking-widest" style={{ color: "rgb(var(--primary))" }}>
//               Add New User
//             </div>
//           </div>
//           <div className="p-5">
//             <div className="grid md:grid-cols-4 gap-3">
//               <div>
//                 <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">Full Name</label>
//                 <Input placeholder="Enter name" value={form.name} onChange={(e) => setForm(p => ({ ...p, name: e.target.value }))} />
//               </div>
//               <div>
//                 <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">Email</label>
//                 <Input placeholder="email@example.com" type="email" value={form.email} onChange={(e) => setForm(p => ({ ...p, email: e.target.value }))} />
//               </div>
//               <div>
//                 <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">Password</label>
//                 <Input placeholder="Password" type="password" value={form.password} onChange={(e) => setForm(p => ({ ...p, password: e.target.value }))} />
//               </div>
//               <div>
//                 <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">Role</label>
//                 <select
//                   className="styled-select w-full px-3 py-2 rounded-xl border bg-[rgb(var(--card))] border-[rgb(var(--border))] text-[rgb(var(--fg))] text-sm outline-none focus:border-[rgb(var(--primary))]"
//                   value={form.role}
//                   onChange={(e) => setForm(p => ({ ...p, role: e.target.value }))}
//                 >
//                   {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
//                 </select>
//               </div>
//             </div>
//             <div className="flex items-center gap-3 mt-4">
//               <Button onClick={create} loading={creating}>
//                 {creating ? "Creating..." : "Create User"}
//               </Button>
//               {msg && (
//                 <div className={`text-sm px-3 py-1.5 rounded-xl font-medium ${
//                   msg.startsWith("✅") ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "bg-red-50 text-red-600 border border-red-200"
//                 }`}>
//                   {msg}
//                 </div>
//               )}
//             </div>
//           </div>
//         </Card>}

//         {/* ── Users table ── */}
//         <Card className="overflow-hidden">
//           <div className="px-5 py-3 border-b border-[rgb(var(--border))] flex items-center justify-between">
//             <div className="text-xs font-bold uppercase tracking-widest" style={{ color: "rgb(var(--primary))" }}>
//               All Users
//             </div>
//             <span
//               className="text-xs font-bold px-2.5 py-0.5 rounded-full text-white"
//               style={{ background: "rgb(var(--primary))" }}
//             >
//               {users.length}
//             </span>
//           </div>

//           {loadingUsers ? (
//             <PageLoader message={creating ? "Adding user..." : "Loading users..."} />
//           ) : users.length === 0 ? (
//             <div className="py-20 text-center opacity-40">
//               <div className="text-sm font-semibold">No users found</div>
//             </div>
//           ) : (
//             <>
//             <div className="overflow-x-auto">
//               <div className="overflow-y-auto max-h-[320px] scrollbar-thin">
//               <table className="w-full text-sm border-collapse min-w-[800px]">
//                 <thead className="sticky top-0 z-10">
//                   <tr style={{ background: "rgb(var(--primary))" }}>
//                     {["Name", "Email", "Role", "Status", "Actions"].map(h => (
//                       <th key={h} className="text-left px-5 py-3 text-white text-[11px] font-bold uppercase tracking-wider border-r border-white/10 last:border-0">
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {users.map((u, i) => {
//                     const rm = ROLE_META[u.role] || ROLE_META.VIEWER;
//                     return (
//                       <tr
//                         key={u._id}
//                         className="border-b border-[rgb(var(--border))] hover:bg-[rgba(var(--primary),0.03)] transition-colors"
//                         style={{ background: i % 2 === 0 ? "transparent" : "rgba(var(--primary),0.015)" }}
//                       >
//                         {/* Name + avatar */}
//                         <td className="px-5 py-3">
//                           <div className="flex items-center gap-3">
//                             <div
//                               className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
//                               style={{ background: rm.color }}
//                             >
//                               {u.name?.[0]?.toUpperCase() || "?"}
//                             </div>
//                             <span className="font-semibold">{u.name}</span>
//                           </div>
//                         </td>
//                         <td className="px-5 py-3 opacity-60 text-sm">{u.email}</td>
//                         <td className="px-5 py-3">
//                           <select
//                             value={u.role}
//                             onChange={(e) => updateRole(u, e.target.value)}
//                             className="px-2.5 py-1 rounded-lg text-xs font-bold border-0 outline-none cursor-pointer"
//                             style={{ background: rm.bg, color: rm.color }}
//                           >
//                             {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
//                           </select>
//                         </td>
//                         <td className="px-5 py-3">
//                           <div className="flex items-center gap-1.5">
//                             <span
//                               className="w-2 h-2 rounded-full"
//                               style={{ background: u.isActive ? "#22c55e" : "#ef4444" }}
//                             />
//                             <span className={`text-xs font-semibold ${u.isActive ? "text-emerald-600" : "text-red-500"}`}>
//                               {u.isActive ? "Active" : "Inactive"}
//                             </span>
//                           </div>
//                         </td>
//                         <td className="px-5 py-3">
//                           <div className="flex gap-2">
//                             <button
//                               onClick={() => toggleActive(u)}
//                               className="px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors"
//                               style={{
//                                 borderColor: u.isActive ? "#fca5a5" : "#86efac",
//                                 color: u.isActive ? "#dc2626" : "#16a34a",
//                                 background: u.isActive ? "#fef2f2" : "#f0fdf4",
//                               }}
//                             >
//                               {u.isActive ? "Disable" : "Enable"}
//                             </button>
//                             <button
//                               onClick={() => resetPassword(u)}
//                               className="px-3 py-1.5 rounded-lg text-xs font-semibold border border-[rgb(var(--border))] hover:border-[rgb(var(--primary))] transition-colors"
//                               style={{ color: "rgb(var(--fg))", background: "transparent" }}
//                             >
//                               Reset Password
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//               </div>
//             </div>
//             {users.length > 5 && (
//               <div className="px-5 py-2 border-t border-[rgb(var(--border))] flex items-center justify-end gap-1.5 opacity-50">
//                 <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12l7 7 7-7"/></svg>
//                 <span className="text-[11px] font-semibold">Scroll to see all {users.length} users</span>
//               </div>
//             )}
//             </>
//           )}
//         </Card>
//       </div>
//     </Layout>
//   );
// }


// above code is commented out, is also good but optionally you can use the below code which is more simplified and clean without much UI/UX but serves the purpose of user management.



import { useEffect, useState } from "react";
import api from "../api/axios";
import Layout from "../components/Layout";
import Card from "../components/UI/Card";
import Input from "../components/UI/Input";
import Button from "../components/UI/Button";
import { PageLoader } from "../components/UI/Spinner";
import { Eye, EyeOff } from "lucide-react";

const ROLES = ["ADMIN", "MANAGER", "CALLER", "VIEWER"];

const ROLE_META = {
  SUPER_ADMIN: { color: "#7c3aed", bg: "#f3e8ff" },
  ADMIN: { color: "#2563eb", bg: "#dbeafe" },
  MANAGER: { color: "#0891b2", bg: "#cffafe" },
  CALLER: { color: "#059669", bg: "#d1fae5" },
  VIEWER: { color: "#64748b", bg: "#f1f5f9" },
};

export default function Users() {
  const [users, setUsers] = useState([]);
  const [msg, setMsg] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(true);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    role: "VIEWER",
  });
  const [creating, setCreating] = useState(false);
  const [showForm, setShowForm] = useState(false);



const [showPassword, setShowPassword] = useState(false);

  async function load() {
    setLoadingUsers(true);
    try {
      const { data } = await api.get("/users");
      setUsers((data.users || []).filter(u => u.role !== "SUPER_ADMIN"));
    } finally {
      setLoadingUsers(false);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function create() {
    if (!form.name.trim()) return setMsg("Name is required.");
    if (!form.email.trim()) return setMsg("Email is required.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      return setMsg("Enter a valid email address.");
    if (!form.password.trim()) return setMsg("Password is required.");
    if (form.password.length < 6)
      return setMsg("Password must be at least 6 characters.");

    setMsg("");
    setCreating(true);
    try {
      await api.post("/users", form);
      setForm({ name: "", email: "", password: "", role: "VIEWER" });
      setMsg("✅ User created successfully");
      setShowForm(false);
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.message || "Create failed");
    } finally {
      setCreating(false);
    }
  }

  async function updateRole(u, role) {
    try {
      await api.put(`/users/${u._id}`, { name: u.name, role });
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.message || "Role update failed");
    }
  }

  async function toggleActive(u) {
    try {
      await api.put(`/users/${u._id}/active`, { isActive: !u.isActive });
      await load();
    } catch (e) {
      setMsg(e?.response?.data?.message || "Status update failed");
    }
  }

  async function resetPassword(u) {
    const newPassword = prompt("Enter new password:");
    if (!newPassword) return;
    try {
      await api.put(`/users/${u._id}/reset-password`, { newPassword });
      alert("Password reset + email sent");
    } catch (e) {
      alert(e?.response?.data?.message || "Password reset failed");
    }
  }

  return (
    <Layout>
      <div className="w-full h-full flex flex-col gap-5">
        {/* Header */}
        <div className="flex items-end justify-between flex-wrap gap-3">
          <div>
            <div
              className="text-[10px] font-bold uppercase tracking-widest mb-1"
              style={{
                color: "rgb(var(--primary))",
                opacity: 0.7,
              }}
            >
              Management
            </div>
            <h1 className="text-2xl font-bold tracking-tight">Users</h1>
          </div>

          <div className="flex items-center gap-3">
            {!loadingUsers && (
              <div
                className="flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-semibold"
                style={{
                  background: "rgba(var(--primary),0.08)",
                  color: "rgb(var(--primary))",
                }}
              >
                <span
                  className="w-2 h-2 rounded-full"
                  style={{ background: "rgb(var(--primary))" }}
                />
                {users.length} Users
              </div>
            )}

            <button
              onClick={() => {
                setShowForm((p) => !p);
                setMsg("");
              }}
              className="flex items-center gap-2 px-4 py-2 rounded-2xl text-sm font-semibold text-white transition-opacity hover:opacity-90"
              style={{ background: "rgb(var(--primary))" }}
            >
              {showForm ? (
                <>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M18 6L6 18M6 6l12 12" />
                  </svg>
                  Cancel
                </>
              ) : (
                <>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                  >
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                  Add New User
                </>
              )}
            </button>
          </div>
        </div>

        {/* Main content */}
        <div
          className={`grid gap-5 items-start ${
            showForm
              ? "grid-cols-1 xl:grid-cols-[360px_minmax(0,1fr)]"
              : "grid-cols-1"
          }`}
        >
          {/* Create user form */}
          {showForm && (
            <Card className="overflow-hidden xl:sticky xl:top-4">
              <div
                className="px-5 py-3 border-b border-[rgb(var(--border))]"
                style={{ background: "rgba(var(--primary),0.04)" }}
              >
                <div
                  className="text-xs font-bold uppercase tracking-widest"
                  style={{ color: "rgb(var(--primary))" }}
                >
                  Add New User
                </div>
              </div>

              <div className="p-5">
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">
                      Full Name
                    </label>
                    <Input
                      placeholder="Enter name"
                      value={form.name}
                      name="new-user-fullname"
                      autoComplete="one-time-code"
                      onChange={(e) =>
                        setForm((p) => ({ ...p, name: e.target.value }))
                      }
                    />
                  </div>

                  <div>
                    <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">
                      Email
                    </label>
                    <Input
                      placeholder="email@example.com"
                      type="email"
                      value={form.email}
                      name="new-user-email-addr"
                      autoComplete="one-time-code"
                      onChange={(e) =>
                        setForm((p) => ({ ...p, email: e.target.value }))
                      }
                    />
                  </div>

                  {/* <div>
                    <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">
                      Password
                    </label>
                    <Input
                      placeholder="Password"
                      type="password"
                      value={form.password}
                      onChange={(e) =>
                        setForm((p) => ({ ...p, password: e.target.value }))
                      }
                    />
                  </div> */}

                  <div>
  <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">
    Password
  </label>

  <div className="relative">
    <Input
      placeholder="Password"
      type={showPassword ? "text" : "password"}
      value={form.password}
      name="new-user-secret"
      autoComplete="one-time-code"
      onChange={(e) =>
        setForm((p) => ({ ...p, password: e.target.value }))
      }
      className="pr-10"
    />

    <button
      type="button"
      onClick={() => setShowPassword((p) => !p)}
      className="absolute right-3 top-1/2 -translate-y-1/2 opacity-60 hover:opacity-100"
    >
      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
    </button>
  </div>
</div>

                  <div>
                    <label className="block text-[11px] font-semibold uppercase tracking-wider opacity-50 mb-1.5">
                      Role
                    </label>
                    <select
                      className="styled-select w-full px-3 py-2 rounded-xl border bg-[rgb(var(--card))] border-[rgb(var(--border))] text-[rgb(var(--fg))] text-sm outline-none focus:border-[rgb(var(--primary))]"
                      value={form.role}
                      onChange={(e) =>
                        setForm((p) => ({ ...p, role: e.target.value }))
                      }
                    >
                      {ROLES.map((r) => (
                        <option key={r} value={r}>
                          {r}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="flex flex-col items-start gap-3 mt-4">
                  <Button onClick={create} loading={creating}>
                    {creating ? "Creating..." : "Create User"}
                  </Button>

                  {msg && (
                    <div
                      className={`text-sm px-3 py-1.5 rounded-xl font-medium ${
                        msg.startsWith("✅")
                          ? "bg-emerald-50 text-emerald-700 border border-emerald-200"
                          : "bg-red-50 text-red-600 border border-red-200"
                      }`}
                    >
                      {msg}
                    </div>
                  )}
                </div>
              </div>
            </Card>
          )}

          {/* Users table */}
          <Card
            className={`overflow-hidden flex flex-col ${
              showForm
                ? "min-h-[calc(100vh-180px)]"
                : "min-h-[calc(100vh-150px)]"
            }`}
          >
            <div className="px-5 py-3 border-b border-[rgb(var(--border))] flex items-center justify-between">
              <div
                className="text-xs font-bold uppercase tracking-widest"
                style={{ color: "rgb(var(--primary))" }}
              >
                All Users
              </div>
              <span
                className="text-xs font-bold px-2.5 py-0.5 rounded-full text-white"
                style={{ background: "rgb(var(--primary))" }}
              >
                {users.length}
              </span>
            </div>

            {loadingUsers ? (
              <div className="flex-1 flex items-center justify-center">
                <PageLoader message={creating ? "Adding user..." : "Loading users..."} />
              </div>
            ) : users.length === 0 ? (
              <div className="flex-1 flex items-center justify-center text-center opacity-40">
                <div className="text-sm font-semibold">No users found</div>
              </div>
            ) : (
              <>
                <div className="flex-1 overflow-hidden">
                  <div className="w-full h-full overflow-auto">
                    <table className="w-full text-sm border-collapse min-w-[800px]">
                      <thead className="sticky top-0 z-10">
                        <tr style={{ background: "rgb(var(--primary))" }}>
                          {["Name", "Email", "Role", "Status", "Actions"].map(
                            (h) => (
                              <th
                                key={h}
                                className="text-left px-5 py-3 text-white text-[11px] font-bold uppercase tracking-wider border-r border-white/10 last:border-0"
                              >
                                {h}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {users.map((u, i) => {
                          const rm = ROLE_META[u.role] || ROLE_META.VIEWER;

                          return (
                            <tr
                              key={u._id}
                              className="border-b border-[rgb(var(--border))] hover:bg-[rgba(var(--primary),0.03)] transition-colors"
                              style={{
                                background:
                                  i % 2 === 0
                                    ? "transparent"
                                    : "rgba(var(--primary),0.015)",
                              }}
                            >
                              <td className="px-5 py-3">
                                <div className="flex items-center gap-3">
                                  <div
                                    className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
                                    style={{ background: rm.color }}
                                  >
                                    {u.name?.[0]?.toUpperCase() || "?"}
                                  </div>
                                  <span className="font-semibold">{u.name}</span>
                                </div>
                              </td>

                              <td className="px-5 py-3 opacity-60 text-sm">
                                {u.email}
                              </td>

                              <td className="px-5 py-3">
                                <select
                                  value={u.role}
                                  onChange={(e) =>
                                    updateRole(u, e.target.value)
                                  }
                                  className="px-2.5 py-1 rounded-lg text-xs font-bold border-0 outline-none cursor-pointer"
                                  style={{ background: rm.bg, color: rm.color }}
                                >
                                  {ROLES.map((r) => (
                                    <option key={r} value={r}>
                                      {r}
                                    </option>
                                  ))}
                                </select>
                              </td>

                              <td className="px-5 py-3">
                                <div className="flex items-center gap-1.5">
                                  <span
                                    className="w-2 h-2 rounded-full"
                                    style={{
                                      background: u.isActive
                                        ? "#22c55e"
                                        : "#ef4444",
                                    }}
                                  />
                                  <span
                                    className={`text-xs font-semibold ${
                                      u.isActive
                                        ? "text-emerald-600"
                                        : "text-red-500"
                                    }`}
                                  >
                                    {u.isActive ? "Active" : "Inactive"}
                                  </span>
                                </div>
                              </td>

                              <td className="px-5 py-3">
                                <div className="flex flex-wrap gap-2">
                                  <button
                                    onClick={() => toggleActive(u)}
                                    className="px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors"
                                    style={{
                                      borderColor: u.isActive
                                        ? "#fca5a5"
                                        : "#86efac",
                                      color: u.isActive
                                        ? "#dc2626"
                                        : "#16a34a",
                                      background: u.isActive
                                        ? "#fef2f2"
                                        : "#f0fdf4",
                                    }}
                                  >
                                    {u.isActive ? "Disable" : "Enable"}
                                  </button>

                                  <button
                                    onClick={() => resetPassword(u)}
                                    className="px-3 py-1.5 rounded-lg text-xs font-semibold border border-[rgb(var(--border))] hover:border-[rgb(var(--primary))] transition-colors"
                                    style={{
                                      color: "rgb(var(--fg))",
                                      background: "transparent",
                                    }}
                                  >
                                    Reset Password
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {users.length > 5 && (
                  <div className="px-5 py-2 border-t border-[rgb(var(--border))] flex items-center justify-end gap-1.5 opacity-50">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M12 5v14M5 12l7 7 7-7" />
                    </svg>
                    <span className="text-[11px] font-semibold">
                      Scroll to see all {users.length} users
                    </span>
                  </div>
                )}
              </>
            )}
          </Card>
        </div>
      </div>
    </Layout>
  );
}